(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-burst"] && !Shopify.designMode) return;
  try {
    
  function assignCommunityClasses() {
    document.querySelectorAll('.xo-community--spike').forEach(function (parent) {
      const children = parent.querySelectorAll('.xo-community-item__wrapper');
      const prefix = 'xo-community-item__wrapper--spike-';

      children.forEach(function (el, i) {
        el.classList.forEach((cls) => {
          if (cls.startsWith('xo-community-item__wrapper--spike-')) {
            el.classList.remove(cls);
          }
        });

        // Add new spike class
        el.classList.add(`${prefix}${i + 1}`);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', assignCommunityClasses);
  document.addEventListener('shopify:section:load', assignCommunityClasses);
  document.addEventListener('shopify:section:select', assignCommunityClasses);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  function assignCommunityClasses() {
    document.querySelectorAll('.xo-community--rounded').forEach(function (parent) {
      const children = parent.querySelectorAll('.xo-community-item__wrapper');
      const prefix = 'xo-community-item__wrapper--rounded-';

      children.forEach(function (el, i) {
        el.classList.forEach((cls) => {
          if (cls.startsWith('xo-community-item__wrapper--rounded-')) {
            el.classList.remove(cls);
          }
        });

        // Add new rounded class
        el.classList.add(`${prefix}${i + 1}`);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', assignCommunityClasses);
  document.addEventListener('shopify:section:load', assignCommunityClasses);
  document.addEventListener('shopify:section:select', assignCommunityClasses);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const togglePassword = document.getElementById('togglePassword');
    const passwordField = document.getElementById('passwordField');
    const eyeOpenPassword = document.getElementById('password-icon-open');
    const eyeHidePassword = document.getElementById('password-icon-hide');

    togglePassword.addEventListener('click', function () {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        eyeOpenPassword.classList.remove('d:none');
        eyeHidePassword.classList.add('d:none');
      } else {
        passwordField.type = 'password';
        eyeOpenPassword.classList.add('d:none');
        eyeHidePassword.classList.remove('d:none');
      }
    });

    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword');
    const confirmPasswordField = document.getElementById('confirmPasswordField');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide');

    toggleConfirmPassword.addEventListener('click', function () {
      if (confirmPasswordField.type === 'password') {
        confirmPasswordField.type = 'text';
        // eyeOpenConfirmPassword.classList.remove('xo-register__password-confirm-icon--hidden');
        // eyeHideConfirmPassword.classList.add('xo-register__password-confirm-icon--hidden');
        eyeOpenConfirmPassword.classList.remove('d:none');
        eyeHideConfirmPassword.classList.add('d:none');
      } else {
        confirmPasswordField.type = 'password';
        // eyeOpenConfirmPassword.classList.add('xo-register__password-confirm-icon--hidden');
        // eyeHideConfirmPassword.classList.remove('xo-register__password-confirm-icon--hidden');
        eyeOpenConfirmPassword.classList.add('d:none');
        eyeHideConfirmPassword.classList.remove('d:none');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const togglePassword = document.getElementById('togglePassword');
    const passwordField = document.getElementById('passwordField');
    const eyeOpenPassword = document.getElementById('password-icon-open');
    const eyeHidePassword = document.getElementById('password-icon-hide');

    togglePassword.addEventListener('click', function () {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        eyeOpenPassword.classList.remove('d:none');
        eyeHidePassword.classList.add('d:none');
      } else {
        passwordField.type = 'password';
        eyeOpenPassword.classList.add('d:none');
        eyeHidePassword.classList.remove('d:none');
      }
    });

    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword');
    const confirmPasswordField = document.getElementById('confirmPasswordField');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide');

    toggleConfirmPassword.addEventListener('click', function () {
      if (confirmPasswordField.type === 'password') {
        confirmPasswordField.type = 'text';
        eyeOpenConfirmPassword.classList.remove('d:none');
        eyeHideConfirmPassword.classList.add('d:none');
      } else {
        confirmPasswordField.type = 'password';
        eyeOpenConfirmPassword.classList.add('d:none');
        eyeHideConfirmPassword.classList.remove('d:none');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
